/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 56);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.6' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return EVENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LIFECYCLE_EVENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return MODES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MESSENGER_MODES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ALLOWED_CONFIG_PROPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return MESSAGES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return THEME_BASE_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return THEME_DEFAULT; });


var EVENTS = {
  CREATED: 'created',
  DESTROYED: 'destroyed',
  CLOSED: 'closed',
  MESSAGE_RECEIVED: 'messageReceived',
  MESSAGE_SENT: 'messageSent',
  CUSTOM_RECEIVED: 'customReceived',
  CONFIG_UPDATED: 'configUpdated',
  STATE_CHANGED: 'stateChanged',
  FIRST_TIME_USER: 'newUser'
};
var LIFECYCLE_EVENTS = Object.values(EVENTS);

var MODES = {
  FULLSCREEN: 'fullscreen',
  SIDEBAR: 'sidebar',
  POPUP: 'popup'
};
var MESSENGER_MODES = Object.values(MODES);

var ALLOWED_CONFIG_PROPS = [
// 'Public' props
'mode', 'popupWidth', 'popupHeight', 'headerText', 'customPromptMessage', 'newChat', 'color', 'botIcon', 'allowBackgroundScroll', 'metadata', 'externalUserId', 'collectUserIpAddress', 'disableAttachments', 'enableRecording', 'autoplayAudio', 'disableInput', 'historyLimit', 'disableReset', 'themeCssUrl', 'customCssUrl', 'themeName', 'themeCssOnly',

// 'Private' props
'standalone', 'botId',

//Positioning
'widgetPosition'];

var MESSAGES = {
  CONFIG: 'fxo-messenger-config',
  REQUEST_CONFIG: 'fxo-messenger-config-request',
  CLOSE: 'fxo-messenger-close',
  DESTROY: 'fxo-messenger-destroy',
  SEND_MESSAGE: 'fxo-messenger-send-message',
  STATE_UPDATE: 'fxo-messenger-state-change',
  MESSAGE_RECEIVED: 'fxo-messenger-message-received',
  MESSAGE_SENT: 'fxo-messenger-message-sent',
  CUSTOM_RECEIVED: 'fxo-messenger-custom-received',
  CONFIG_UPDATED: 'fxo-messenger-config-updated',
  VIEW_MODE_CHANGED: 'fxo-messenger-view-mode-updated',
  FIRST_TIME_USER: 'fxo-messenger-new-user',
  CLEAR_HISTORY: 'fxo-messenger-clear-history',
  FORGET_USER: 'fxo-forget-user'
};

var THEME_BASE_URL = 'https://d2u2e8j2jrnyta.cloudfront.net';
var THEME_DEFAULT = 'classic';

/***/ }),
/* 2 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/**
 * Simple Event Emitter base class.
 */

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EventEmitter = function () {
  function EventEmitter() {
    _classCallCheck(this, EventEmitter);

    this._handlers = {};
  }

  _createClass(EventEmitter, [{
    key: 'on',
    value: function on(name, handler) {
      this._handlers[name] = this._handlers[name] || [];
      this._handlers[name].push(handler);
    }
  }, {
    key: 'emit',
    value: function emit(name, data) {
      var _handlers = this._handlers[name];
      if (_handlers) {
        _handlers.forEach(function (handler) {
          return handler(data);
        });
      }
    }
  }, {
    key: 'off',
    value: function off(name, cb) {
      var _handlers = this._handlers[name];
      if (_handlers) {
        var index = void 0;
        while ((index = _handlers.indexOf(cb)) > -1) {
          _handlers.splice(index, 1);
        }
      }
    }
  }, {
    key: 'removeListeners',
    value: function removeListeners(name) {
      if (name) {
        this._handlers[name] = {};
      } else {
        this._handlers = {};
      }
    }
  }]);

  return EventEmitter;
}();

/* harmony default export */ __webpack_exports__["a"] = (EventEmitter);

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(5)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(12);
var defined = __webpack_require__(8);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 8 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(2);
var core = __webpack_require__(0);
var hide = __webpack_require__(11);
var redefine = __webpack_require__(41);
var ctx = __webpack_require__(30);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 10 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(36);
var createDesc = __webpack_require__(40);
module.exports = __webpack_require__(4) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(29);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(38);
var enumBugKeys = __webpack_require__(32);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 14 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 15 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 16 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(24);
__webpack_require__(25);
__webpack_require__(19);

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parse;


function parse(url) {
  var qs = {};

  var idx = url.indexOf('?');
  if (idx > -1) {
    qs = url.slice(idx + 1).split('&').reduce(function (map, kv) {
      var parts = kv.split('=');
      if (parts.length === 2) {
        map[parts[0]] = parts[1];
      }
      return map;
    }, {});
  }

  return qs;
}

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*! srcdoc-polyfill - v1.0.0 - 2017-01-29
 * http://github.com/jugglinmike/srcdoc-polyfill/
 * Copyright (c) 2017 Mike Pennisi; Licensed MIT */
!function (a, b) {
  var c = window.srcDoc;
   true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_RESULT__ = function (d) {
    b(d, c), a.srcDoc = d;
  }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : 'object' == (typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) ? b(exports, c) : (a.srcDoc = {}, b(a.srcDoc, c));
}(this, function (a, b) {
  var c,
      d,
      e,
      f = !!('srcdoc' in document.createElement('iframe')),
      g = 'Polyfill may not function in the presence of the `sandbox` attribute. Consider using the `force` option.',
      h = /\ballow-same-origin\b/,
      i = function i(a, b) {
    var c = a.getAttribute('sandbox');
    'string' != typeof c || h.test(c) || (b && b.force ? a.removeAttribute('sandbox') : b && b.force === !1 || (e(g), a.setAttribute('data-srcdoc-polyfill', g)));
  },
      j = {
    compliant: function compliant(a, b, c) {
      b && (i(a, c), a.setAttribute('srcdoc', b));
    },
    legacy: function legacy(a, b, c) {
      var d;
      a && a.getAttribute && (b ? a.setAttribute('srcdoc', b) : b = a.getAttribute('srcdoc'), b && (i(a, c), d = "javascript: window.frameElement.getAttribute('srcdoc');", a.contentWindow && (a.contentWindow.location = d), a.setAttribute('src', d)));
    }
  },
      k = a;
  if (e = window.console && window.console.error ? function (a) {
    window.console.error('[srcdoc-polyfill] ' + a);
  } : function () {}, k.set = j.compliant, k.noConflict = function () {
    return window.srcDoc = b, k;
  }, !f) for (k.set = j.legacy, d = document.getElementsByTagName('iframe'), c = d.length; c--;) {
    k.set(d[c]);
  }
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_event_emitter__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_Constants__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_MessengerManager__ = __webpack_require__(23);
/**
 * This script is used by the parent page to embed the widget.
 * It creates an iframe.
 */



var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





function reduceToAllowedConfig(config) {
  return __WEBPACK_IMPORTED_MODULE_1__lib_Constants__["a" /* ALLOWED_CONFIG_PROPS */].reduce(function (acc, k) {
    if (config[k] !== undefined) {
      acc[k] = config[k];
    }
    return acc;
  }, {});
}

function checkValid(value, predicate) {
  if (value === undefined) {
    return true;
  }
  return predicate ? predicate(value) : value.length > 0;
}

// Public API

/**
 * The API for interacting with the Flow XO Web Messenger.
 *
 * Methods (see methods below for more details):
 * - sendMessage: send a message as the user
 * - setConfig: set the config for current and future messenger windows
 * - getState: get the state and config of the current window
 * - create: create a new messenger window
 * - destroy: shutdown the current messenger window
 * - toggle: close any open messenger window or create one if none
 * - clear: clears the chat history
 * - forget:  deletes the user data in local storage so the next time the conversation loads it will be a new one.
 *
 * The API singleton published events about the messenger lifecycle.
 *
 * Subscribe using the `.on(eventName, callback<eventData>)` method.
 *
 * You can unsubscribe using `.removeListeners(<optional eventName>)`. If no
 * event name is specified all listeners are removed.
 *
 * Note for each event a convinience methods exists too named
 * `.on<EventName>(callback)`, e.g. `.onMessageReceived(callback)`. The callback
 * is passed the event data.
 *
 * Events:
 * - created
 * - destroyed
 * - messageReceived
 * - messageSent
 * - configUpdated
 * - stateChanged
 *
 */

var MessengerAPI = function (_EventEmitter) {
  _inherits(MessengerAPI, _EventEmitter);

  function MessengerAPI(id) {
    _classCallCheck(this, MessengerAPI);

    var _this = _possibleConstructorReturn(this, (MessengerAPI.__proto__ || Object.getPrototypeOf(MessengerAPI)).call(this));

    _this.manager = new __WEBPACK_IMPORTED_MODULE_2__lib_MessengerManager__["a" /* default */]();
    _this.id = id;

    // Bind to this.manager to proxy events
    _this.EVENT_NAMES.forEach(function (name) {
      _this.manager.on(name, function (data) {
        _this.emit(name, data);
      });
    });

    var self = _this;
    _this.on('created', function () {
      self.setConfig({
        metadata: {
          hostUrl: window.location.href,
          parentUrl: window.location != window.parent.location ? document.referrer : document.location.href
        }
      });
    });
    return _this;
  }

  /**
   * Send a message from the current messenger window. Some metadata about the
   * user's client is also sent with every message. Any custom metadata specifed
   * in the `metadata` parameter will be added to the default set, and override
   * any of the default metadata options if they have the same property name.
   *
   * @param text The message text body
   * @param metadata Any optional metadata parameters.
   * @returns Boolean Returns false if there was no messenger window yet created
   */


  _createClass(MessengerAPI, [{
    key: 'sendMessage',
    value: function sendMessage(text, metadata) {
      if (!text) {
        throw new Error('The message cannot be blank.');
      }

      return this.manager.sendMessage(text, metadata || {});
    }

    /**
     * Set the messenger configuration for the current or any future messenger
     * windows. You can specify one or more property
     *
     * Valid config values are:
     * - fullscreen: Boolean determines whether messenger is shown as a sidebar or fullscreen
     * - headerText: String the message to display in the window top bar
     * - customPromptMessage: String the prompt placeholder text shown in the message box.
     * - color: String a valid CSS color value
     * - botIcon: String a URL to the icon to display for the bot
     *
     * @param config Object the messenger configuration options
     * @returns Boolean Returns false if any of the configuration options are invalid
     */

  }, {
    key: 'setConfig',
    value: function setConfig(config) {
      var _this2 = this;

      config = reduceToAllowedConfig(config);

      var validMode = checkValid(config.mode, function (x) {
        return _this2.MODES.indexOf(x) > -1;
      });
      var validHeaderText = checkValid(config.headerText);
      var validCustomPromptMessage = checkValid(config.customPromptMessage);
      var validColor = checkValid(config.color);
      var validIcon = checkValid(config.botIcon);
      var validStandalone = checkValid(config.standalone, function (s) {
        return s === true;
      });
      var validAllowBackgroundScroll = checkValid(config.allowBackgroundScroll, function (s) {
        return s === true;
      });
      var validBotId = checkValid(config.botId);
      var validMetadata = checkValid(config.metadata, function (v) {
        return v;
      });

      if (!(validMode && validHeaderText && validColor && validIcon && validStandalone && validBotId && validAllowBackgroundScroll && validMetadata && validCustomPromptMessage)) {
        return false;
      }
      this.manager.setConfig(config);
      return true;
    }

    /**
     * Return the current messenger configuration and the state of the messenger
     * window if one is open
     * @returns Object the current configuration properties and state of the messenger window or undefined if no window is open
     */

  }, {
    key: 'getState',
    value: function getState() {
      return this.manager.getInstanceState();
    }

    /**
     * Create a new messenger window. If one is already open it will destroyed
     * and a new window created.
     */

  }, {
    key: 'create',
    value: function create(containerElement) {
      this.manager.createInstance(containerElement, this.id);
    }

    /**
     * Destroy the current open messenger window.
     * @returns Boolean true if a window was open and destroyed
     */

  }, {
    key: 'destroy',
    value: function destroy() {
      return this.manager.destroyCurrent();
    }

    /**
     *  Clears the history of the current open messenger window.
     */

  }, {
    key: 'clear',
    value: function clear() {
      return this.manager.clearCurrent();
    }
  }, {
    key: 'forget',
    value: function forget() {
      return this.manager.forget();
    }

    /**
     * Toggle the state of the messenger window.
     * If the window is open it will be destroyed, and vice versa.
     * @returns Boolean true if a window is opened and false if closed.
     */

  }, {
    key: 'toggle',
    value: function toggle() {
      return this.manager.toggleCurrentState();
    }
  }]);

  return MessengerAPI;
}(__WEBPACK_IMPORTED_MODULE_0_common_event_emitter__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (MessengerAPI);


var EVENT_NAMES = [].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_1__lib_Constants__["b" /* LIFECYCLE_EVENTS */]));

MessengerAPI.prototype.MODES = [].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_1__lib_Constants__["c" /* MESSENGER_MODES */]));
MessengerAPI.prototype.EVENT_NAMES = EVENT_NAMES;

// Setup convinience method for adding event listeners
EVENT_NAMES.forEach(function (name) {
  MessengerAPI.prototype['on' + (name[0].toUpperCase() + name.slice(1))] = function (callback) {
    if (callback) {
      this.on(name, callback);
    }
  };
  MessengerAPI.prototype['off' + (name[0].toUpperCase() + name.slice(1))] = function (callback) {
    if (callback) {
      this.off(name, callback);
    }
  };
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = index;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_Constants__ = __webpack_require__(1);


function index(themeCss, customCss, themeName) {
  if (themeCss) {
    themeCss = decodeURIComponent(themeCss);
  } else {
    themeCss = __WEBPACK_IMPORTED_MODULE_0__lib_Constants__["g" /* THEME_BASE_URL */] + '/' + (themeName || __WEBPACK_IMPORTED_MODULE_0__lib_Constants__["h" /* THEME_DEFAULT */]) + '.css';
  }
  if (customCss) {
    customCss = decodeURIComponent(customCss);
  }

  var themeCssLink = '\n  <link\n  rel="stylesheet"\n  href="' + themeCss + '"/>';

  var customCssLink = '';
  if (customCss) {
    customCssLink = '\n   <link \n   rel="stylesheet"\n   href="' + customCss + '"/>';
  }

  return '\n  <!DOCTYPE html>\n  <html lang="en">\n    <head>\n      <meta charset="UTF-8" />\n      <meta\n        name="viewport"\n        content="initial-scale=1.0, user-scalable=no, maximum-scale=1.0, width=device-width"\n      />\n      <meta http-equiv="X-UA-Compatible" content="ie=edge" />\n      <title>Flow XO Web Messenger</title>\n      ' + themeCssLink + '\n      ' + customCssLink + '\n    </head>\n    <body>\n      <div id="app" class="web-messenger">\n        <div class="web-messenger-header">\n          <div class="web-messenger-title">\n            <div class="web-messenger-title-skeleton"></div>\n          </div>\n        </div>\n        <div class="web-messenger-messages">\n          <div class="web-messenger-message">\n            <div class="web-messenger-message-icon-placeholder"></div>\n            <div class="web-messenger-message-bubble">\n              <div class="web-messenger-typing">\n                <div class="bounce1"></div>\n                <div class="bounce2"></div>\n                <div class="bounce3"></div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n      <script src="' + "https://widget.flowxo.com" + '/messenger.dll.js"></script>\n      <script src="' + "https://widget.flowxo.com" + '/messenger.js"></script>\n    </body>\n  </html>\n  ';
}

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_event_emitter__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Constants__ = __webpack_require__(1);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// If width falls below this number we are assuming we want the fullscreen.
var FullscreenThreshold = 500;

/**
 * Instance of a web messenger.
 * Encapsulates the iframe containing the web messenger
 */

var FxoMessenger = function (_EventEmitter) {
  _inherits(FxoMessenger, _EventEmitter);

  function FxoMessenger() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var containerElement = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    _classCallCheck(this, FxoMessenger);

    var _this = _possibleConstructorReturn(this, (FxoMessenger.__proto__ || Object.getPrototypeOf(FxoMessenger)).call(this));

    _this.config = data;

    _this.state = 'loading';

    _this._eventHandler = _this._processPostMessageCommands.bind(_this);

    //If a container element is present, we'll ignore popup height because
    //the messenger is not being hosted as a popup, but inline
    if (_this.config.popupHeight && _this.config.popupHeight.trim() !== '' && !containerElement) {
      _this.config.mode = 'popup';
    }

    _this._addMessenger(containerElement);
    _this._addPostMessageListener();
    return _this;
  }

  _createClass(FxoMessenger, [{
    key: 'destroy',
    value: function destroy() {
      this.removeListeners();
      this._removePostMessageListener();
      this._removeMessenger();
    }
  }, {
    key: 'setConfig',
    value: function setConfig(config) {
      this.config = config;
      this._sendPostMessageCommand(__WEBPACK_IMPORTED_MODULE_2__Constants__["e" /* MESSAGES */].CONFIG, { config: config });
      this._updateViewMode();
    }
  }, {
    key: 'getState',
    value: function getState() {
      var _config = this.config,
          color = _config.color,
          fullscreen = _config.fullscreen,
          headerText = _config.headerText,
          botIcon = _config.botIcon,
          disableAttachments = _config.disableAttachments,
          enableRecording = _config.enableRecording,
          autoplayAudio = _config.autoplayAudio,
          collectUserIpAddress = _config.collectUserIpAddress,
          testConsole = _config.testConsole;

      return {
        state: this.state,
        color: color,
        fullscreen: fullscreen,
        headerText: headerText,
        botIcon: botIcon,
        testConsole: testConsole,
        disableAttachments: disableAttachments,
        enableRecording: enableRecording,
        autoplayAudio: autoplayAudio,
        collectUserIpAddress: collectUserIpAddress
      };
    }
  }, {
    key: 'sendMessage',
    value: function sendMessage(text, metadata) {
      this._sendPostMessageCommand(__WEBPACK_IMPORTED_MODULE_2__Constants__["e" /* MESSAGES */].SEND_MESSAGE, {
        text: text,
        metadata: metadata
      });
    }
  }, {
    key: '_sendPostMessageCommand',


    // 'private' methods

    value: function _sendPostMessageCommand(type, data) {
      var command = Object.assign({ type: type }, data);
      this._iframe.contentWindow.postMessage(command, '*');
    }

    // Process any commands received from the messenger iframe

  }, {
    key: '_processPostMessageCommands',
    value: function _processPostMessageCommands(payload) {
      var message = payload.data;
      switch (message.type) {
        // Internal messages
        case __WEBPACK_IMPORTED_MODULE_2__Constants__["e" /* MESSAGES */].REQUEST_CONFIG:
          this.setConfig(this.config);
          break;
        case __WEBPACK_IMPORTED_MODULE_2__Constants__["e" /* MESSAGES */].CLOSE:
          this.emit(__WEBPACK_IMPORTED_MODULE_2__Constants__["d" /* EVENTS */].CLOSED);
          this.destroy();
          break;

        // Externally usable events
        case __WEBPACK_IMPORTED_MODULE_2__Constants__["e" /* MESSAGES */].STATE_UPDATE:
          this.state = message.state;
          this.emit(__WEBPACK_IMPORTED_MODULE_2__Constants__["d" /* EVENTS */].STATE_CHANGED, this.state);
          break;
        case __WEBPACK_IMPORTED_MODULE_2__Constants__["e" /* MESSAGES */].MESSAGE_RECEIVED:
          this.emit(__WEBPACK_IMPORTED_MODULE_2__Constants__["d" /* EVENTS */].MESSAGE_RECEIVED, message.message);
          break;
        case __WEBPACK_IMPORTED_MODULE_2__Constants__["e" /* MESSAGES */].MESSAGE_SENT:
          this.emit(__WEBPACK_IMPORTED_MODULE_2__Constants__["d" /* EVENTS */].MESSAGE_SENT, message.message);
          break;
        case __WEBPACK_IMPORTED_MODULE_2__Constants__["e" /* MESSAGES */].CUSTOM_RECEIVED:
          this.emit(__WEBPACK_IMPORTED_MODULE_2__Constants__["d" /* EVENTS */].CUSTOM_RECEIVED, message.custom);
          if (message.custom && message.custom.body && message.custom.body.eval && message.custom.body.eval.length > 0) {
            try {
              eval(message.custom.body.eval);
            } catch (ex) {
              console.log('Could not eval custom javascript (' + message.custom.body.eval + ') because of an error:' + ex);
            }
          }
          break;
        case __WEBPACK_IMPORTED_MODULE_2__Constants__["e" /* MESSAGES */].CONFIG_UPDATED:
          this.emit(__WEBPACK_IMPORTED_MODULE_2__Constants__["d" /* EVENTS */].CONFIG_UPDATED);
          break;
        case __WEBPACK_IMPORTED_MODULE_2__Constants__["e" /* MESSAGES */].FIRST_TIME_USER:
          this.emit(__WEBPACK_IMPORTED_MODULE_2__Constants__["d" /* EVENTS */].FIRST_TIME_USER);
          break;
      }
    }
  }, {
    key: '_addMessenger',
    value: function _addMessenger() {
      var _Object$assign;

      var containerElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var position = this.config.widgetPosition || 'right';
      var opPosition = position === 'right' ? 'left' : 'right';

      this._usesExternalContainer = !!containerElement;
      this._addStylesheet();
      this._calcIsFullscreen();
      // To get around what appears to be a rendering big in Chrome 66, we need to surround
      // the iFrame in a container and apply the box shadow to that rather than to the
      // iFrame itself.

      var _getWidthAndHeightFor = this._getWidthAndHeightForMode(),
          width = _getWidthAndHeightFor.width,
          height = _getWidthAndHeightFor.height;

      var containerSize = this._getWidthAndHeightForContainer();

      // Create iframe and add it to the host.
      var iFrameContainer = containerElement || document.createElement('div');
      var iframe = document.createElement('iframe');
      this._element = iframe;
      if (!this._usesExternalContainer) {
        Object.assign(iFrameContainer, {
          id: ' fxo-messenger-iframe-container',
          className: 'fxo-messenger-iframe-container'
        });
      }
      Object.assign(iframe, {
        id: 'fxo-messenger-iframe',
        className: 'fxo-messenger-iframe',
        scrolling: 'no',
        width: width,
        height: height,
        srcdoc: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__index__["a" /* default */])(this.config.themeCssUrl, this.config.customCssUrl, this.config.themeName),
        allowFullscreen: true,
        allowTransparency: true
      });
      Object.assign(iframe.style, (_Object$assign = {
        'border': 'none',
        'position': 'fixed',
        'bottom': 0
      }, _defineProperty(_Object$assign, position, 0), _defineProperty(_Object$assign, 'z-index', 9998), _Object$assign));

      if (!this.config.fullscreen && !this._usesExternalContainer) {
        var _Object$assign2;

        Object.assign(iFrameContainer.style, (_Object$assign2 = {
          'width': containerSize.width,
          'height': containerSize.height,
          'position': 'fixed'
        }, _defineProperty(_Object$assign2, position, '0px'), _defineProperty(_Object$assign2, 'bottom', '0px'), _defineProperty(_Object$assign2, 'z-index', '9998'), _defineProperty(_Object$assign2, 'box-shadow', '0 1px 6px rgba(17, 54, 84, .04), 0 2px 32px rgba(17, 54, 84, .08)'), _Object$assign2));

        Object.assign(iframe.style, _defineProperty({}, 'margin-' + opPosition, '20px'));
      }
      iFrameContainer.appendChild(this._iframe);
      try {
        if (this.config.fullscreen) {
          document.body.classList.add('fxo-messenger-fullscreen');
        }
        if (!this.config.allowBackgroundScroll) {
          document.body.classList.add('fxo-messenger-noscroll');
        }
      } catch (error) {
        console.error('Error adding class to parent body element.', error);
      }

      this._containerElement = iFrameContainer;
      if (!this._usesExternalContainer) {
        document.body.appendChild(this._container);
      }
    }
  }, {
    key: '_getWidthAndHeightForMode',
    value: function _getWidthAndHeightForMode() {
      var width = void 0;
      var height = '100%';
      switch (this.config.mode) {
        case __WEBPACK_IMPORTED_MODULE_2__Constants__["f" /* MODES */].FULLSCREEN:
          width = '100%';
          break;
        case __WEBPACK_IMPORTED_MODULE_2__Constants__["f" /* MODES */].POPUP:
          width = this.config.popupWidth || 400;
          height = this.config.popupHeight || 400;
          break;
        default:
          width = this.config.fullscreen ? '100%' : this.config.popupWidth || 400;
          break;
      }
      return { width: width, height: height };
    }
  }, {
    key: '_getWidthAndHeightForContainer',
    value: function _getWidthAndHeightForContainer() {
      var width = void 0;
      var height = '100%';
      switch (this.config.mode) {
        case __WEBPACK_IMPORTED_MODULE_2__Constants__["f" /* MODES */].FULLSCREEN:
          width = '100%';
          break;
        case __WEBPACK_IMPORTED_MODULE_2__Constants__["f" /* MODES */].POPUP:
          width = this.config.popupWidth || '400px';
          height = this.config.popupHeight || '400px';
          break;
        default:
          width = this.config.fullscreen ? '100%' : this.config.popupWidth || '400px';
          break;
      }
      return { width: width, height: height };
    }
  }, {
    key: '_updateViewMode',
    value: function _updateViewMode() {
      Object.assign(this._element, this._getWidthAndHeightForMode());
      this._sendPostMessageCommand(__WEBPACK_IMPORTED_MODULE_2__Constants__["e" /* MESSAGES */].VIEW_MODE_CHANGED);
    }
  }, {
    key: '_clearHistory',
    value: function _clearHistory() {
      this._sendPostMessageCommand(__WEBPACK_IMPORTED_MODULE_2__Constants__["e" /* MESSAGES */].CLEAR_HISTORY);
    }
  }, {
    key: '_forget',
    value: function _forget() {
      this._sendPostMessageCommand(__WEBPACK_IMPORTED_MODULE_2__Constants__["e" /* MESSAGES */].FORGET_USER);
    }
  }, {
    key: '_removeMessenger',
    value: function _removeMessenger() {
      this._sendPostMessageCommand(__WEBPACK_IMPORTED_MODULE_2__Constants__["e" /* MESSAGES */].DESTROY);
      if (!this._usesExternalContainer) {
        document.body.removeChild(this._container);
      } else {
        this._iframe.remove();
      }
      this._removeStylesheet();
    }
  }, {
    key: '_addPostMessageListener',
    value: function _addPostMessageListener() {
      window.addEventListener('message', this._eventHandler);
    }
  }, {
    key: '_removePostMessageListener',
    value: function _removePostMessageListener() {
      window.removeEventListener('message', this._eventHandler);
    }
  }, {
    key: '_addStylesheet',
    value: function _addStylesheet() {
      // Create stylesheet and add it to host
      var style = document.createElement('style');
      this._stylesheet = style;
      Object.assign(style, {
        id: 'fxo-messenger-styles',
        type: 'text/css'
      });

      document.body.classList.add('fxo-messenger-open');
      style.appendChild(document.createTextNode('.fxo-messenger-fullscreen {overflow:hidden;height:100%;width:100%;position:fixed} .fxo-messenger-noscroll {overflow:hidden!important}'));
      document.head.appendChild(style);
    }
  }, {
    key: '_removeStylesheet',
    value: function _removeStylesheet() {
      try {
        document.body.classList.remove('fxo-messenger-fullscreen');
        document.body.classList.remove('fxo-messenger-noscroll');
        document.body.classList.remove('fxo-messenger-open');
      } catch (error) {
        console.error('Error removing class from parent body element.', error);
      }
      document.head.removeChild(this._stylesheet);
    }
  }, {
    key: '_calcIsFullscreen',
    value: function _calcIsFullscreen() {
      this.config.fullscreen = window.innerWidth < FullscreenThreshold;
    }
  }, {
    key: 'state',
    get: function get() {
      return this._state;
    },
    set: function set(newState) {
      this._state = newState;
    }
  }, {
    key: '_container',
    get: function get() {
      return this._containerElement;
    }
  }, {
    key: '_iframe',
    get: function get() {
      return this._element;
    }
  }]);

  return FxoMessenger;
}(__WEBPACK_IMPORTED_MODULE_0_common_event_emitter__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (FxoMessenger);

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_event_emitter__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Constants__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FxoMessenger__ = __webpack_require__(22);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * Web messenger instance manager.
 * Ensures only a single messenger instances lives on the page.
 */

var MessengerManager = function (_EventEmitter) {
  _inherits(MessengerManager, _EventEmitter);

  function MessengerManager() {
    _classCallCheck(this, MessengerManager);

    return _possibleConstructorReturn(this, (MessengerManager.__proto__ || Object.getPrototypeOf(MessengerManager)).apply(this, arguments));
  }

  _createClass(MessengerManager, [{
    key: 'createInstance',
    value: function createInstance() {
      var _this2 = this;

      var containerElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      this._containerElement = containerElement;
      // Install itself in the global
      if (this._removeExistingMessenger()) {
        console.warn('FxoMessenger:', 'Found another instance of FxoMessenger. Removing old instance. Installing new one.');
      }
      var messenger = new __WEBPACK_IMPORTED_MODULE_2__FxoMessenger__["a" /* default */](this.config, containerElement);
      this._messengerInstance = messenger;

      messenger.on(__WEBPACK_IMPORTED_MODULE_1__Constants__["d" /* EVENTS */].CLOSED, function () {
        //console.log('Messenger closed itself');
        _this2._messengerInstance = undefined;
        _this2.emit(__WEBPACK_IMPORTED_MODULE_1__Constants__["d" /* EVENTS */].DESTROYED);
      });

      __WEBPACK_IMPORTED_MODULE_1__Constants__["b" /* LIFECYCLE_EVENTS */].forEach(function (name) {
        messenger.on(name, function (data) {
          _this2.emit(name, data);
        });
      });

      this.emit(__WEBPACK_IMPORTED_MODULE_1__Constants__["d" /* EVENTS */].CREATED);

      return true;
    }
  }, {
    key: 'destroyCurrent',
    value: function destroyCurrent() {
      return !!this._removeExistingMessenger();
    }
  }, {
    key: 'clearCurrent',
    value: function clearCurrent() {
      var messenger = this._messengerInstance;
      if (messenger) {
        messenger._clearHistory();
      }
    }
  }, {
    key: 'forget',
    value: function forget() {
      var messenger = this._messengerInstance;
      if (messenger) {
        messenger._forget();
      }
    }
  }, {
    key: 'toggleCurrentState',
    value: function toggleCurrentState() {
      if (!this._removeExistingMessenger()) {
        return this.createInstance(this._containerElement);
      }
      return false;
    }

    // Set config for all future instances too

  }, {
    key: 'setConfig',
    value: function setConfig(config) {
      var priorConfig = this.config || {};
      var priorMeta = this.config && this.config.metadata || {};
      var newConfig = Object.assign({}, priorConfig, config);
      var newMeta = Object.assign({}, priorMeta, config.metadata);
      newConfig.metadata = newMeta;
      this.config = newConfig;
      var messenger = this._messengerInstance;
      if (messenger) {
        messenger.setConfig(this.config);
      }
    }
  }, {
    key: 'getInstanceState',
    value: function getInstanceState() {
      var messenger = this._messengerInstance;
      return messenger && messenger.getState() || {
        state: 'detached'
      };
    }
  }, {
    key: 'sendMessage',
    value: function sendMessage(text, metadata) {
      var messenger = this._messengerInstance;
      if (!messenger) {
        return false;
      }
      return messenger.sendMessage(text, metadata || {});
    }

    // 'private' methods

  }, {
    key: '_removeExistingMessenger',
    value: function _removeExistingMessenger() {
      var messenger = this._messengerInstance;
      if (messenger) {
        messenger.destroy();
        this._messengerInstance = undefined;
        this.emit(__WEBPACK_IMPORTED_MODULE_1__Constants__["d" /* EVENTS */].DESTROYED);
      }
      return !!messenger;
    }
  }, {
    key: '_messengerInstance',
    get: function get() {
      return this._currentFxoMessenger;
    },
    set: function set(obj) {
      this._currentFxoMessenger = obj;
    }
  }]);

  return MessengerManager;
}(__WEBPACK_IMPORTED_MODULE_0_common_event_emitter__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (MessengerManager);

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(48);
module.exports = __webpack_require__(0).Object.assign;


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(49);
module.exports = __webpack_require__(0).Object.values;


/***/ }),
/* 26 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(6);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(7);
var toLength = __webpack_require__(45);
var toAbsoluteIndex = __webpack_require__(44);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 29 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(26);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(6);
var document = __webpack_require__(2).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 32 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(4) && !__webpack_require__(5)(function () {
  return Object.defineProperty(__webpack_require__(31)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 34 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(13);
var gOPS = __webpack_require__(37);
var pIE = __webpack_require__(14);
var toObject = __webpack_require__(46);
var IObject = __webpack_require__(12);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(5)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(27);
var IE8_DOM_DEFINE = __webpack_require__(33);
var toPrimitive = __webpack_require__(47);
var dP = Object.defineProperty;

exports.f = __webpack_require__(4) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 37 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(10);
var toIObject = __webpack_require__(7);
var arrayIndexOf = __webpack_require__(28)(false);
var IE_PROTO = __webpack_require__(42)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys = __webpack_require__(13);
var toIObject = __webpack_require__(7);
var isEnum = __webpack_require__(14).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) if (isEnum.call(O, key = keys[i++])) {
      result.push(isEntries ? [key, O[key]] : O[key]);
    } return result;
  };
};


/***/ }),
/* 40 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(2);
var hide = __webpack_require__(11);
var has = __webpack_require__(10);
var SRC = __webpack_require__(16)('src');
var TO_STRING = 'toString';
var $toString = Function[TO_STRING];
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(0).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(43)('keys');
var uid = __webpack_require__(16);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(0);
var global = __webpack_require__(2);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(34) ? 'pure' : 'global',
  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(15);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(15);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(8);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(6);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(9);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(35) });


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(9);
var $values = __webpack_require__(39)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 50 */,
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__messenger_embed_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__widget_embed_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_qs__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_decoder__ = __webpack_require__(52);







// The widget data should be included on the script
// tag inside the `data-fxo-widget` attribute.
// If this isn't present, fail!
var scriptElements = document.querySelectorAll('script[data-fxo-widget]');
if (!scriptElements.length) {
  throw new Error('Script was not added correctly. Ensure the script contains data under the `data-fxo-widget` attribute.');
}

var callbacks = [];
var messengers = window.FxoMessengers || {};
scriptElements.forEach(function (scriptElement) {
  // widgetData is a base64 encoded,
  // stringified JSON object.
  var widgetData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common_decoder__["a" /* decodeJSONFromBase64 */])(scriptElement.getAttribute('data-fxo-widget'));
  if (!widgetData) {
    throw new Error('Widget data was invalid.');
  }
  var id = scriptElement.id || widgetData.web.botId || 'unknown';
  if (window.FxoMessengers && window.FxoMessengers[id]) {
    console.log('Messenger already loaded (' + id + ')');
    return;
  }

  // // If we received an older version of the web config,
  // // transform it into the newer one
  // if (widgetData.web && widgetData.web.data) {
  //   const webConfig = decodeJSONFromBase64(widgetData.web.data);
  //   if (!webConfig) {
  //     throw new Error('Messenger data was invalid.');
  //   }
  //   widgetData.web = webConfig;
  // }

  var hideWelcomeMessageDuration = scriptElement.getAttribute('data-hide-welcome-message-days');
  if (hideWelcomeMessageDuration) {
    widgetData.hideWelcomeForDays = hideWelcomeMessageDuration;
  }
  var welcomeRevealAfterSecs = scriptElement.getAttribute('data-reveal-welcome-message-seconds');
  if (welcomeRevealAfterSecs) {
    widgetData.welcomeRevealAfterSecs = welcomeRevealAfterSecs;
  }
  var welcomeHideAfterSecs = scriptElement.getAttribute('data-hide-welcome-message-seconds');
  if (welcomeHideAfterSecs) {
    widgetData.welcomeHideAfterSecs = welcomeHideAfterSecs;
  }
  var themeUrl = scriptElement.getAttribute('data-theme-css-url');
  var customUrl = scriptElement.getAttribute('data-custom-css-url');
  var themeName = scriptElement.getAttribute('data-theme-name');
  var themeCssOnly = scriptElement.getAttribute('data-theme-css-only');
  var widgetIconUrl = scriptElement.getAttribute('data-widget-icon-url');
  var targetElementSelector = scriptElement.getAttribute('data-target-element-selector');
  var widgetPosition = scriptElement.getAttribute('data-widget-position');
  var embedMode = scriptElement.getAttribute('data-embed-mode') || 'sidebar';
  if (themeUrl) {
    widgetData.themeCssUrl = themeUrl;
  }
  if (customUrl) {
    widgetData.customCssUrl = customUrl;
  }
  if (themeName) {
    widgetData.themeName = themeName;
  }
  if (themeCssOnly) {
    widgetData.themeCssOnly = !!themeCssOnly;
  }
  if (widgetIconUrl) {
    widgetData.widgetIconUrl = widgetIconUrl;
  }
  if (widgetPosition) {
    widgetData.widgetPosition = widgetPosition;
  }

  var widget = void 0;
  if (!targetElementSelector && embedMode === 'sidebar') {
    // We have our widget data.
    // Configure the widget.
    widget = new __WEBPACK_IMPORTED_MODULE_1__widget_embed_js__["a" /* default */](widgetData);
  }

  // Set up the web messenger.
  var messenger = new __WEBPACK_IMPORTED_MODULE_0__messenger_embed_js__["a" /* default */](id);

  // We only set the botId, allowBackgroundScroll and theme css here. Everything else can be fetched
  // from the botmaster.
  messenger.setConfig({
    botId: widgetData.web.botId,
    allowBackgroundScroll: widgetData.allowBackgroundScroll,
    popupHeight: widgetData.popupHeight,
    themeCssUrl: widgetData.themeCssUrl,
    customCssUrl: widgetData.customCssUrl,
    themeName: widgetData.themeName,
    themeCssOnly: widgetData.themeCssOnly,
    widgetPosition: widgetData.widgetPosition
  });

  var overlay = void 0,
      overlayContainer = void 0;
  function showMessenger(mode, targetElement) {
    if (mode === 'sidebar') {
      return messenger.toggle();
    } else if (mode === 'inline') {
      messenger.setConfig({ mode: 'fullscreen', standalone: true });
      messenger.create(targetElement);
    } else if (mode === 'overlay') {
      if (overlay) {
        Object.assign(overlay.style, { display: 'block' });
      } else {
        overlay = document.createElement('div');
        overlay.id = 'fxo-overlay';
        Object.assign(overlay.style, {
          'width': '100%',
          'height': '100%',
          'background-color': 'rgba(0,0,0,.8)',
          'z-index': '9998',
          'position': 'fixed',
          'left': 0,
          'top': 0
        });
        overlay.addEventListener('click', function () {
          messenger.destroy();
        });

        overlayContainer = document.createElement('div');
        overlayContainer.id = 'fxo-overlay-chat-container';
        Object.assign(overlayContainer.style, {
          'border': 'none',
          'position': 'fixed',
          'top': '50%',
          'left': '50%',
          'transform': 'translateX(-50%) translateY(-50%)',
          'width': '100%',
          'max-width': '1024px',
          'height': '100%',
          'max-height': '800px'
        });
        overlay.appendChild(overlayContainer);

        messenger.setConfig({
          mode: 'fullscreen'
        });
      }
      document.body.appendChild(overlay);
      document.body.classList.add('fxo-messenger-noscroll');
      messenger.create(overlayContainer);
    }
  }

  function hideMessenger() {
    if (overlay) {
      Object.assign(overlay.style, { display: 'none' });
      document.body.classList.remove('fxo-messenger-noscroll');
    }
  }

  if (widget) {
    widget.on('revealWebMessenger', function () {
      //console.log('revealWebMessenger');
      showMessenger('sidebar');
    });
    messenger.on('destroyed', function () {
      widget.sendMessageToWidget('widget:collapse');
    });

    widget.render();
    // And expose it.
    window.FxoWidget = widget.getPublicAPI();
  } else if (targetElementSelector) {
    var targetElement = document.querySelector(targetElementSelector);
    if (!targetElement) {
      console.log('No target element with the selector ' + targetElementSelector + ' could be found. Your Flow XO bot cannot be embedded when the data-target-element attribute is set but does not exist.');
      return;
    }
    if (embedMode === 'sidebar') {
      messenger.on('destroyed', function () {
        targetElement.classList.remove('fxo-messenger-active');
      });
      targetElement.addEventListener('click', function () {
        showMessenger('sidebar');
        targetElement.classList.add('fxo-messenger-active');
      });
    } else if (embedMode === 'inline') {
      showMessenger('inline', targetElement);
    }
    if (embedMode === 'overlay') {
      targetElement.addEventListener('click', function () {
        showMessenger('overlay');
      });
      messenger.on('destroyed', function () {
        hideMessenger();
      });
    }
  }

  // If we have a callback, then call it.
  var qs = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_qs__["a" /* parse */])(scriptElement.src);
  var callback = qs.callback || widgetData.callback;
  if (callback && window[callback]) {
    callbacks.push(callback);
  }
  messengers[id] = messenger;
  window.FxoMessenger = window.FxoMessenger || messenger;
});

window.FxoMessengers = messengers;
callbacks.forEach(function (callback) {
  window[callback]();
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = decodeJSONFromBase64;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_base64__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_base64___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_base64__);




function decodeJSONFromBase64(encoded) {
  try {
    return JSON.parse(__WEBPACK_IMPORTED_MODULE_0_js_base64__["Base64"].decode(encoded));
  } catch (e) {
    console.warn('Data to decode was invalid:', e);
  }
}

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_event_emitter__ = __webpack_require__(3);
/* global document, window */
/* jshint scripturl: true */

/**
 * This script is used by the parent page to embed the widget.
 * It creates an iframe and injects the HTML, CSS and JS
 * needed to run the widget.
 */



var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



function escapeHtml(unsafe) {
  var text = document.createTextNode(unsafe);
  var div = document.createElement('div');
  div.appendChild(text);
  return div.innerHTML;
}

var Widget = function (_EventEmitter) {
  _inherits(Widget, _EventEmitter);

  function Widget(widgetData) {
    _classCallCheck(this, Widget);

    var _this = _possibleConstructorReturn(this, (Widget.__proto__ || Object.getPrototypeOf(Widget)).call(this));

    _this.processMessageFromWidget = _this.processMessageFromWidget.bind(_this);

    // Generate the configuration that we need to
    // create the widget.
    _this.config = {
      zIndex: 9997
    };

    var channel = void 0;

    // If channel data was passed in, and the correct
    // data is present, use it as widget config.
    var data = widgetData['web'];
    var label = data.label || 'Web';
    Object.assign(data, {
      key: 'web',
      label: label,
      labelWidth: label.length * 10 // Auto calc label width
    });
    channel = data;
    _this.config.channel = channel;

    // Grab some additional data that may be set.
    ['theme', 'revealAfterSecs', 'welcomeRevealAfterSecs', 'welcomeHideAfterSecs', 'hideWelcomeForDays', 'userId', 'userPaidPlan', 'zIndex', 'popupHeight', 'themeCssUrl', 'customCssUrl', 'themeName', 'themeCssOnly', 'widgetIconUrl', 'widgetPosition'].forEach(function (k) {
      if (widgetData.hasOwnProperty(k)) {
        _this.config[k] = widgetData[k];
      }
    });

    // Grab any additional data that must be escaped.
    ['welcomeText'].forEach(function (k) {
      if (widgetData.hasOwnProperty(k)) {
        _this.config[k] = escapeHtml(widgetData[k]);
      }
    });
    return _this;
  }

  _createClass(Widget, [{
    key: 'render',
    value: function render() {
      if (!this.iframe) {
        var position = this.config.widgetPosition || 'right';
        var iframeStyles = '\n        .fxo-widget-iframe {\n          border: none;\n          display: block;\n          position: fixed;\n          bottom: 15px;\n          ' + position + ': 0;\n          z-index: ' + this.config.zIndex + ';\n        }\n        @media (min-width: 769px) {\n          .fxo-widget-iframe {\n            ' + position + ': 10px;\n          }\n        }\n        @media (min-width: 1025px) {\n          .fxo-widget-iframe {\n            bottom: 25px;\n            ' + position + ': 20px;\n          }\n        }\n      ';

        if (this.config.themeCssUrl) {
          var themePref = document.createElement('link');
          themePref.href = this.config.themeCssUrl;
          themePref.rel = 'preload';
          themePref.as = 'style';
          document.head.appendChild(themePref);
        } else {
          var _themePref = document.createElement('link');
          var themeBaseUrl = this.config.themeBaseUrl || 'https://d2u2e8j2jrnyta.cloudfront.net';
          var themeName = this.config.themeName || 'classic';
          _themePref.href = themeBaseUrl + '/' + themeName + '.css';
          _themePref.rel = 'preload';
          _themePref.as = 'style';
          document.head.appendChild(_themePref);
        }
        if (this.config.customCssUrl) {
          var _themePref2 = document.createElement('link');
          _themePref2.href = this.config.customCssUrl;
          _themePref2.rel = 'preload';
          _themePref2.as = 'style';
          document.head.appendChild(_themePref2);
        }

        var style = document.createElement('style');
        style.type = 'text/css';
        style.appendChild(document.createTextNode(iframeStyles));
        document.head.appendChild(style);

        // Create iframe and add it to the host.
        this.iframe = document.createElement('iframe');
        this.iframe.id = 'fxo-widget-iframe';
        this.iframe.className = 'fxo-widget-iframe';
        this.iframe.scrolling = 'no';
        this.iframe.width = 100;
        this.iframe.height = 100;
        this.iframe.title = 'Chatbot';
        this.iframe.src = "https://widget.flowxo.com/widget.html";
        this.iframe.allowFullscreen = true;

        document.body.appendChild(this.iframe);

        // Listen for messages from the iframe
        window.addEventListener('message', this.processMessageFromWidget, false);
      }
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      window.removeEventListener('message', this.processMessageFromWidget, false);
      this.sendMessageToWidget('widget:destroy');
      document.body.removeChild(this.iframe);
    }

    // Process any received messages

  }, {
    key: 'processMessageFromWidget',
    value: function processMessageFromWidget(payload) {
      var message = void 0;
      try {
        message = JSON.parse(payload.data);
      } catch (e) {
        // Not for us
        return;
      }

      switch (message.action) {
        case 'fxo-widget-ready':
          // Send the widget our config.
          this.sendMessageToWidget('widget:init', this.config);
          break;
        case 'fxo-widget-resize':
          // Resize the iframe.
          if (this.iframe) {
            this.iframe.width = message.payload.width;
            this.iframe.height = message.payload.height;
          }
          break;
        case 'fxo-widget-reveal-web-messenger':
          // Show the web messenger.
          this.emit('revealWebMessenger');
          break;
      }
    }
  }, {
    key: 'sendMessageToWidget',
    value: function sendMessageToWidget(action) {
      var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // Send message to iframe.
      if (this.iframe && this.iframe.contentWindow) {
        var message = JSON.stringify({ action: action, payload: payload });
        this.iframe.contentWindow.postMessage(message, '*');
      }
    }
  }, {
    key: 'getPublicAPI',
    value: function getPublicAPI() {
      return {
        destroy: this.destroy.bind(this)
      };
    }
  }]);

  return Widget;
}(__WEBPACK_IMPORTED_MODULE_0_common_event_emitter__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Widget);

/***/ }),
/* 54 */
/***/ (function(module, exports) {

/*
 *  base64.js
 *
 *  Licensed under the BSD 3-Clause License.
 *    http://opensource.org/licenses/BSD-3-Clause
 *
 *  References:
 *    http://en.wikipedia.org/wiki/Base64
 */
;(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined'
        ? module.exports = factory(global)
        : typeof define === 'function' && define.amd
        ? define(factory) : factory(global)
}((
    typeof self !== 'undefined' ? self
        : typeof window !== 'undefined' ? window
        : typeof global !== 'undefined' ? global
: this
), function(global) {
    'use strict';
    // existing version for noConflict()
    var _Base64 = global.Base64;
    var version = "2.4.5";
    // if node.js, we use Buffer
    var buffer;
    if (typeof module !== 'undefined' && module.exports) {
        try {
            buffer = require('buffer').Buffer;
        } catch (err) {}
    }
    // constants
    var b64chars
        = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    var b64tab = function(bin) {
        var t = {};
        for (var i = 0, l = bin.length; i < l; i++) t[bin.charAt(i)] = i;
        return t;
    }(b64chars);
    var fromCharCode = String.fromCharCode;
    // encoder stuff
    var cb_utob = function(c) {
        if (c.length < 2) {
            var cc = c.charCodeAt(0);
            return cc < 0x80 ? c
                : cc < 0x800 ? (fromCharCode(0xc0 | (cc >>> 6))
                                + fromCharCode(0x80 | (cc & 0x3f)))
                : (fromCharCode(0xe0 | ((cc >>> 12) & 0x0f))
                   + fromCharCode(0x80 | ((cc >>>  6) & 0x3f))
                   + fromCharCode(0x80 | ( cc         & 0x3f)));
        } else {
            var cc = 0x10000
                + (c.charCodeAt(0) - 0xD800) * 0x400
                + (c.charCodeAt(1) - 0xDC00);
            return (fromCharCode(0xf0 | ((cc >>> 18) & 0x07))
                    + fromCharCode(0x80 | ((cc >>> 12) & 0x3f))
                    + fromCharCode(0x80 | ((cc >>>  6) & 0x3f))
                    + fromCharCode(0x80 | ( cc         & 0x3f)));
        }
    };
    var re_utob = /[\uD800-\uDBFF][\uDC00-\uDFFFF]|[^\x00-\x7F]/g;
    var utob = function(u) {
        return u.replace(re_utob, cb_utob);
    };
    var cb_encode = function(ccc) {
        var padlen = [0, 2, 1][ccc.length % 3],
        ord = ccc.charCodeAt(0) << 16
            | ((ccc.length > 1 ? ccc.charCodeAt(1) : 0) << 8)
            | ((ccc.length > 2 ? ccc.charCodeAt(2) : 0)),
        chars = [
            b64chars.charAt( ord >>> 18),
            b64chars.charAt((ord >>> 12) & 63),
            padlen >= 2 ? '=' : b64chars.charAt((ord >>> 6) & 63),
            padlen >= 1 ? '=' : b64chars.charAt(ord & 63)
        ];
        return chars.join('');
    };
    var btoa = global.btoa ? function(b) {
        return global.btoa(b);
    } : function(b) {
        return b.replace(/[\s\S]{1,3}/g, cb_encode);
    };
    var _encode = buffer ?
        buffer.from && Uint8Array && buffer.from !== Uint8Array.from
        ? function (u) {
            return (u.constructor === buffer.constructor ? u : buffer.from(u))
                .toString('base64')
        }
        :  function (u) {
            return (u.constructor === buffer.constructor ? u : new  buffer(u))
                .toString('base64')
        }
        : function (u) { return btoa(utob(u)) }
    ;
    var encode = function(u, urisafe) {
        return !urisafe
            ? _encode(String(u))
            : _encode(String(u)).replace(/[+\/]/g, function(m0) {
                return m0 == '+' ? '-' : '_';
            }).replace(/=/g, '');
    };
    var encodeURI = function(u) { return encode(u, true) };
    // decoder stuff
    var re_btou = new RegExp([
        '[\xC0-\xDF][\x80-\xBF]',
        '[\xE0-\xEF][\x80-\xBF]{2}',
        '[\xF0-\xF7][\x80-\xBF]{3}'
    ].join('|'), 'g');
    var cb_btou = function(cccc) {
        switch(cccc.length) {
        case 4:
            var cp = ((0x07 & cccc.charCodeAt(0)) << 18)
                |    ((0x3f & cccc.charCodeAt(1)) << 12)
                |    ((0x3f & cccc.charCodeAt(2)) <<  6)
                |     (0x3f & cccc.charCodeAt(3)),
            offset = cp - 0x10000;
            return (fromCharCode((offset  >>> 10) + 0xD800)
                    + fromCharCode((offset & 0x3FF) + 0xDC00));
        case 3:
            return fromCharCode(
                ((0x0f & cccc.charCodeAt(0)) << 12)
                    | ((0x3f & cccc.charCodeAt(1)) << 6)
                    |  (0x3f & cccc.charCodeAt(2))
            );
        default:
            return  fromCharCode(
                ((0x1f & cccc.charCodeAt(0)) << 6)
                    |  (0x3f & cccc.charCodeAt(1))
            );
        }
    };
    var btou = function(b) {
        return b.replace(re_btou, cb_btou);
    };
    var cb_decode = function(cccc) {
        var len = cccc.length,
        padlen = len % 4,
        n = (len > 0 ? b64tab[cccc.charAt(0)] << 18 : 0)
            | (len > 1 ? b64tab[cccc.charAt(1)] << 12 : 0)
            | (len > 2 ? b64tab[cccc.charAt(2)] <<  6 : 0)
            | (len > 3 ? b64tab[cccc.charAt(3)]       : 0),
        chars = [
            fromCharCode( n >>> 16),
            fromCharCode((n >>>  8) & 0xff),
            fromCharCode( n         & 0xff)
        ];
        chars.length -= [0, 0, 2, 1][padlen];
        return chars.join('');
    };
    var atob = global.atob ? function(a) {
        return global.atob(a);
    } : function(a){
        return a.replace(/[\s\S]{1,4}/g, cb_decode);
    };
    var _decode = buffer ?
        buffer.from && Uint8Array && buffer.from !== Uint8Array.from
        ? function(a) {
            return (a.constructor === buffer.constructor
                    ? a : buffer.from(a, 'base64')).toString();
        }
        : function(a) {
            return (a.constructor === buffer.constructor
                    ? a : new buffer(a, 'base64')).toString();
        }
        : function(a) { return btou(atob(a)) };
    var decode = function(a){
        return _decode(
            String(a).replace(/[-_]/g, function(m0) { return m0 == '-' ? '+' : '/' })
                .replace(/[^A-Za-z0-9\+\/]/g, '')
        );
    };
    var noConflict = function() {
        var Base64 = global.Base64;
        global.Base64 = _Base64;
        return Base64;
    };
    // export Base64
    global.Base64 = {
        VERSION: version,
        atob: atob,
        btoa: btoa,
        fromBase64: decode,
        toBase64: encode,
        utob: utob,
        encode: encode,
        encodeURI: encodeURI,
        btou: btou,
        decode: decode,
        noConflict: noConflict
    };
    // if ES5 is available, make Base64.extendString() available
    if (typeof Object.defineProperty === 'function') {
        var noEnum = function(v){
            return {value:v,enumerable:false,writable:true,configurable:true};
        };
        global.Base64.extendString = function () {
            Object.defineProperty(
                String.prototype, 'fromBase64', noEnum(function () {
                    return decode(this)
                }));
            Object.defineProperty(
                String.prototype, 'toBase64', noEnum(function (urisafe) {
                    return encode(this, urisafe)
                }));
            Object.defineProperty(
                String.prototype, 'toBase64URI', noEnum(function () {
                    return encode(this, true)
                }));
        };
    }
    //
    // export Base64 to the namespace
    //
    if (global['Meteor']) { // Meteor.js
        Base64 = global.Base64;
    }
    // module.exports and AMD are mutually exclusive.
    // module.exports has precedence.
    if (typeof module !== 'undefined' && module.exports) {
        module.exports.Base64 = global.Base64;
    }
    else if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define([], function(){ return global.Base64 });
    }
    // that's it!
    return {Base64: global.Base64}
}));


/***/ }),
/* 55 */,
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(17);
module.exports = __webpack_require__(51);


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// embed.js